/** Auth surface copy (sign-in/up, invite acceptance) — absorbs artifacts/web/src/lib/auth-copy.ts. */
export const auth = {
  // Clerk-hosted sign-in/sign-up localization (shared web/desktop/player).
  clerk: {
    signIn: {
      start: {
        title: "Welcome back",
        subtitle: "Sign in to access your account",
      },
    },
    signUp: {
      start: {
        title: "Create your account",
        subtitle: "Get started today",
      },
    },
  },

  // Invite-acceptance page.
  invite: {
    title: "Workspace invitation",
    invalidLink: "Invalid invite link.",
    loadError: {
      title: "Couldn't load invitation",
      description:
        "Something went wrong while loading this invitation. Check your connection and try again.",
    },
    expired: "This invite is invalid or has expired.",
    // Rendered around bold <strong> entity names: "{lead} <b>{workspace}</b> {as} <b>{group}</b>."
    invited: {
      lead: "You have been invited to join",
      as: "as",
    },
    invitedEmail: "Invited email: {email}",
    signInToAccept: "Sign in to accept",
    signedInAs: "Signed in as: {email}",
    unknownEmail: "unknown",
    // Rendered around bold <strong> emails: "{lead} <b>{invited}</b>{middle} <b>{current}</b>."
    mismatch: {
      lead: "This invite was sent to",
      middle: ", but you are signed in as",
      signOutSwitch: "Sign out and switch account",
    },
    accept: "Accept invitation",
    acceptError: "Could not accept invitation.",
  },
} as const;
